import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { OpinionreviewService } from './opinionreview.service'
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalService } from '../../local.service'
@Component({
  selector: 'app-opinionreview',
  templateUrl: './opinionreview.component.html',
  styleUrls: ['./opinionreview.component.css']
})
export class OpinionreviewComponent implements OnInit {

  reportType = '';
  selectedDaterange: any;

  userid:number;
  constructor(private datePipe: DatePipe, private reportService: OpinionreviewService,
     private toastr: ToastrService, private SpinnerService: NgxSpinnerService, private localService: LocalService) { }

  ngOnInit() {
    this.userid = +this.localService.getJsonValue('userid');
  }

  generateReport() {
    this.SpinnerService.show();
    var daterange = ''; var input = []; var _input=[];
    if (!this.reportType) {
      this.toastr.error('Please select reviewed or notreviewed to generate report');
      this.SpinnerService.hide();
      return;
    }
    if (!this.selectedDaterange) {
      this.toastr.error('Please select daterange to generate report');
      this.SpinnerService.hide();
      return;
    }

    if (this.selectedDaterange != undefined && this.selectedDaterange.length != 0) {

      let date1 = this.datePipe.transform(this.selectedDaterange[0], 'yyyy-MM-dd');
      let date2 = this.datePipe.transform(this.selectedDaterange[1], 'yyyy-MM-dd');    
      let datefield = this.reportType == 'reviewed' ? 'z.updatedon' : 'd.createdon';
      daterange = datefield + ' BETWEEN concat(\'' + date1.toString() + '\'," ","00:00:01")::timestamp and concat(\'' + date2.toString() + '\'," ","23:59:59")::TIMESTAMP';
    }
    else {
      daterange = null;
    }

    input.push({
      "active_p": 1, "mode_p": this.reportType, "daterange_p": daterange,
    });
    _input.push({
      "active_p": 1, "mode_p": 'federalreviewed', "daterange_p": daterange,
    });
    let list: any = []; let federalList:any=[];
    this.reportService.getReport(input[0]).toPromise().then(res => {
      //console.log(res);
      if (res.status == 200 && res.body.length > 0) {
        list = JSON.parse(res.body[0].spformdashboardgeneratereport)
        this.reportService.getReport(_input[0]).toPromise().then(res1 => {
          if (res1.status == 200 && res1.body.length > 0) {
            federalList = JSON.parse(res1.body[0].spformdashboardgeneratereport);
           // if(federalList){
              var _finaloutput = [];
          
              _finaloutput = JSON.parse(JSON.stringify(federalList));
              federalList = _finaloutput;

              if (list || federalList) {
                var finaloutput = [];
                
                finaloutput = JSON.parse(JSON.stringify(list));
                list = finaloutput;    
      
                var today = new Date();
                var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                var dateTime = date + ' ' + time;
                const wb: XLSX.WorkBook = XLSX.utils.book_new();  
                let worksheet : XLSX.WorkSheet;           
                let worksheet2: XLSX.WorkSheet;        

              
                //const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
               // const workbook: XLSX.WorkBook=XLSX.utils.book_new();
               if(list){
                worksheet = XLSX.utils.json_to_sheet(list); 
                XLSX.utils.book_append_sheet(wb, worksheet, "data");
               }
                
              if(federalList){
                worksheet2 = XLSX.utils.json_to_sheet(federalList);
              XLSX.utils.book_append_sheet(wb, worksheet2, "General Use Report");
              }
                const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                let fromdate = this.datePipe.transform(new Date(this.selectedDaterange[0]), 'dd MMM yyyy');
                let todate = this.datePipe.transform(new Date(this.selectedDaterange[1]), 'dd MMM yyyy');
                let type = this.reportType == 'notreviewed' ? 'Not Reviewed' : 'Reviewed';
                let filename = type + ' - ' + fromdate + ' to ' + todate + '.xlsx';
                this.saveAsExcelFile(excelBuffer, filename);
                this.selectedDaterange = null;
                this.reportType = null;
                this.SpinnerService.hide();
        
                this.toastr.success('Report generated successfully');
               
              }
              else {
                this.toastr.info('There is no data for selected date range');
                this.SpinnerService.hide();
                return;
              }




          //  }
         
      
      }

    },
    err => {
      console.log(err);
      this.toastr.error('Error While generating the Report');
      this.SpinnerService.hide();
   
   
    });



       

     
     
      }
     

    }, err => {
      console.log(err);
      this.toastr.error('Error While generating the Report');
      this.SpinnerService.hide();
    })

  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    var link = document.createElement("a");
    link.download = fileName;
    var url = window.URL.createObjectURL(data);
    link.href = url;
    document.body.appendChild(link);
    link.download = fileName;
    link.click();
    document.body.removeChild(link);
    self.close()
  }

}
